import h from "../helper/helper";
var MINUTE = 60 * 1000;
var Burst = /** @class */ (function () {
    function Burst() {
        var _this = this;
        this.getItems = function () {
            return _this.items;
        };
        this.hasItem = function (item) {
            return _this.items.indexOf(item) > -1;
        };
        this.addItem = function (item) {
            if (!_this.hasItems()) {
                _this.chunkID = item.getChunkID();
            }
            _this.items.push(item);
            _this.items.sort(function (m1, m2) {
                return m1.getTime() - m2.getTime();
            });
        };
        this.removeAllExceptLast = function () {
            _this.items.splice(0, _this.items.length - 1);
        };
        this.firstItem = function () {
            return _this.items[0];
        };
        this.lastItem = function () {
            return _this.items[_this.items.length - 1];
        };
        this.hasItems = function () {
            return _this.items.length > 0;
        };
        this.fitsItem = function (item) {
            if (!_this.hasItems()) {
                return true;
            }
            return _this.sameChunk(item) &&
                _this.sameSender(item) &&
                _this.continousMessage(item) &&
                _this.sameDay(item) &&
                _this.timeDifference(item) < MINUTE * 10;
        };
        this.getChunkID = function () { return _this.chunkID; };
        this.sameChunk = function (item) {
            if (!item) {
                return false;
            }
            return _this.getChunkID() === item.getChunkID();
        };
        this.sameSender = function (message) {
            return _this.firstItem().data.sender.id === message.data.sender.id;
        };
        this.sameDay = function (message) {
            if (!message) {
                return false;
            }
            if (message instanceof Burst) {
                message = message.firstItem();
            }
            var date1 = new Date(h.parseDecimal(_this.firstItem().getTime()));
            var date2 = new Date(h.parseDecimal(message.getTime()));
            if (date1.getDate() !== date2.getDate()) {
                return false;
            }
            if (date1.getMonth() !== date2.getMonth()) {
                return false;
            }
            if (date1.getFullYear() !== date2.getFullYear()) {
                return false;
            }
            return true;
        };
        this.timeDifference = function (item) {
            return Math.abs(h.parseDecimal(item.getTime()) - h.parseDecimal(_this.firstItem().getTime()));
        };
        this.isMe = function () {
            return _this.firstItem().data.sender.me;
        };
        this.isOther = function () {
            return !_this.firstItem().data.sender.me;
        };
        this.sender = function () {
            return _this.firstItem().data.sender;
        };
        this.items = [];
    }
    Burst.prototype.continousMessage = function (item) {
        if (this.items.findIndex(function (m) { return m.getClientID() === item.getPreviousID(); }) !== -1) {
            return true;
        }
        return this.items.findIndex(function (m) { return m.getPreviousID() === item.getClientID(); }) !== -1;
    };
    return Burst;
}());
export default Burst;



//////////////////
// WEBPACK FOOTER
// ./js/messages/burst.ts
// module id = null
// module chunks = 